var BASWebServices;
(function (BASWebServices) {
    var UploadElementMultiController = (function () {
        function UploadElementMultiController($scope, $rootScope, $upload, $timeout, $http, $sce, wsData, configService, browser, ngDialog) {
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$upload = $upload;
            this.$timeout = $timeout;
            this.$http = $http;
            this.$sce = $sce;
            this.wsData = wsData;
            this.configService = configService;
            this.browser = browser;
            this.ngDialog = ngDialog;
            this.largeFileSize = 100000000;
            this.largeFilesSelected = false;
            this.largeFileWarningText = 'You have selected one or more files that are very large (> 100 Megabytes). With files of this size, it is advisable to have an email sent to you once the processed results are ready. Please consider the “user email notification” found among the expert options.';
            this.$scope.uemc = this;
            this.$scope.allFilesUploaded = new Array();
            this.$rootScope.dimmingPage = false;
            this.$rootScope.$broadcast("dimming_screen_off");
            var _scope = this.$scope;
            var _rootScope = this.$rootScope;
            if (this.browser.getBrowserType() != "chrome") {
                this.$rootScope.$broadcast('messageForBox', 'WARNING', 'You are not using Google Chrome/Chromium. We advise you to click on the file area rather than using drag & drop. Some browsers are unreliable when using drag & drop, especially (but not exclusively) with thousands of files.');
            }
        }
        UploadElementMultiController.get_TEMPLATE_HACK_FILE_NAME_START = function () {
            return UploadElementMultiController.TEMPLATE_HACK_FILE_NAME_START;
        };
        UploadElementMultiController.prototype.onFileSelectMulti = function ($files, serviceName, pairedFileLocation, pairDefinition, ignoredFilesInWhichScopeVar, uploadvariabledefinition, event) {
            if ($files.length == 0 && event.type === "drop") {
                this.$rootScope.$broadcast('messageForBox', 'ERROR', 'Files could not be dropped (click me for more information)!', "It seems that you have dragged & dropped to many files to the drop area. This can unfortunately happen on some operating systems. A number we tested successfully on Linux and Windows machines are 4500 files. If this still does not work for you, please try to use a smaller amount of files.");
            }
            this.$scope[pairedFileLocation] = null;
            this.$scope[ignoredFilesInWhichScopeVar] = null;
            var filenameFilter = function (filename) {
                return (function (file, i, arr) {
                    if (file.name == filename) {
                        return true;
                    }
                    else {
                        return false;
                    }
                });
            };
            if (this.$scope.$files == null) {
                this.$scope.$files = $files;
            }
            else {
                for (var k in $files) {
                    var fileToBeAdded = $files[k];
                    var filtered = this.$scope.$files.filter(filenameFilter(fileToBeAdded.name));
                    if (filtered.length >= 1) {
                    }
                    else {
                        this.$scope.$files.push(fileToBeAdded);
                    }
                }
            }
            var allSupportedFileExtensionsArray = [];
            Object.keys(uploadvariabledefinition).forEach(function (key) {
                allSupportedFileExtensionsArray.push(key);
            });
            var problemToAbortFound = false;
            console.log("Time: " + new Date().toTimeString());
            for (var i = 0; i < $files.length; i++) {
                var $file = $files[i];
                var currExtension = allSupportedFileExtensionsArray.filter(function (str) {
                    if ($file.name.toLowerCase().lastIndexOf(str.toLowerCase()) != -1) {
                        return true;
                    }
                    else {
                        return false;
                    }
                });
                if (currExtension.length < 1) {
                    var message = "Unsupported file type on file: " + $file.name + ".";
                    this.$rootScope.$broadcast('messageForBox', 'WARNING', 'Invalid file extensions (supported ones are ' + allSupportedFileExtensionsArray + ')', message);
                    this.$rootScope.dimmingPage = false;
                    this.$rootScope.$broadcast("dimming_screen_off");
                }
                var containsBadChar = BASWebServices.ConfigService.CONTAINS_BAD_CHARACTER($file.name);
                if (containsBadChar) {
                    this.$rootScope.$broadcast('messageForBox', 'ERROR', 'Aborting: Filename contains bad character. Only a-z, A-Z, 0-9, . (dot), - (dash), and _ (underscore) are supported.', 'Unsupported character in file name ' + $file.name + '.');
                    this.$rootScope.dimmingPage = false;
                    this.$rootScope.$broadcast("dimming_screen_off");
                    this.$scope.$files = null;
                    return;
                }
                if (!($file.name.indexOf(".wav") != -1
                    || $file.name.indexOf(".nis") != -1
                    || $file.name.indexOf(".nist") != -1)) {
                    var DISABLED = true;
                    if (!DISABLED) {
                        var reader = new FileReader();
                        var _dialog = this.ngDialog;
                        var _scope = this.$scope;
                        BASWebServices.Helper.checkEncoding($file, _dialog, _scope);
                    }
                }
            }
            var files = this.$scope.$files;
            if (serviceName === 'runPipeline' || serviceName === 'runPipelineWithASR' || serviceName === 'runChunker' || serviceName === 'runASR') {
                this.largeFilesSelected = false;
                for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
                    var file = files_1[_i];
                    if (file.size > this.largeFileSize) {
                        this.largeFilesSelected = true;
                        this.$rootScope.$broadcast('messageForBox', 'WARNING', 'Please consider “user email notification” for large files', this.largeFileWarningText);
                        break;
                    }
                }
            }
            if (pairDefinition != null) {
                var templateHackFile = files.filter(function (file) {
                    if (file.name.lastIndexOf(UploadElementMultiController.TEMPLATE_HACK_FILE_NAME_START) != -1) {
                        return true;
                    }
                    else {
                        return false;
                    }
                });
                if (templateHackFile.length > 1) {
                    var detailedMessage = 'Only one template file starting with >' + UploadElementMultiController.TEMPLATE_HACK_FILE_NAME_START + '< is allowed. The following files were found:\n';
                    var delimiter = ", ";
                    var counter = 0;
                    for (var _a = 0, templateHackFile_1 = templateHackFile; _a < templateHackFile_1.length; _a++) {
                        var name_1 = templateHackFile_1[_a];
                        counter++;
                        if ((counter + 1) == templateHackFile.length) {
                            delimiter = " and ";
                        }
                        else if (counter == templateHackFile.length) {
                            delimiter = ".";
                        }
                        detailedMessage += (name_1 + delimiter);
                    }
                    detailedMessage += " Please drop only one of them!";
                    this.$rootScope.$broadcast('messageForBox', 'ERROR', 'More than one template file found. Aborting!', detailedMessage);
                    return;
                }
                else if (templateHackFile.length == 1) {
                    var ext = templateHackFile[0].name.replace(UploadElementMultiController.TEMPLATE_HACK_FILE_NAME_START + ".", "");
                    if (pairDefinition[ext.toLowerCase()] == null) {
                        var detailedMessage = 'Template file found (_TEMPLATE_FILE_), but it has an unsupported extension >' + ext + '<. Aborting!';
                        this.$rootScope.$broadcast('messageForBox', 'ERROR', 'Unsupported template file found. Aborting!', detailedMessage);
                        this.$scope.$files = null;
                        return;
                    }
                    var pairsAndIgnored = null;
                    pairsAndIgnored = this.getFilePairsAndIgnoredForTemplateHACK(files, pairDefinition);
                    if (pairsAndIgnored == null) {
                        $files = null;
                        this.$scope.$files = null;
                        return;
                    }
                }
                else {
                    pairsAndIgnored = this.getFilePairsAndIgnoredForTemplateHACK(files, pairDefinition);
                }
                if (pairsAndIgnored[0].length > 0)
                    this.$scope["pairedFilesLocally"] = pairsAndIgnored[0];
                if (pairsAndIgnored[1].length > 0)
                    this.$scope["ignoredFilesLocally"] = pairsAndIgnored[1];
            }
            else {
                var filesGood = new Array();
                var filesIgnored = new Array();
                for (var i = 0; i < this.$scope.$files.length; i++) {
                    var $file = this.$scope.$files[i];
                    var ignoredFile = true;
                    for (var j = 0; j < allSupportedFileExtensionsArray.length; j++) {
                        if ($file.name.toLowerCase().lastIndexOf(allSupportedFileExtensionsArray[j].toLowerCase()) != -1) {
                            ignoredFile = false;
                            break;
                        }
                    }
                    if (ignoredFile)
                        filesIgnored.push($file);
                    else {
                        var fileArray = new Array();
                        fileArray.push($file);
                        filesGood.push(fileArray);
                    }
                }
                this.$scope["pairedFilesLocally"] = filesGood;
                if (filesIgnored.length > 0)
                    this.$scope["ignoredFilesLocally"] = filesIgnored;
            }
        };
        UploadElementMultiController.prototype.uploadFilesQueue = function (supportedFileExtensions, uploadedFilesToWhichScopeVar, pairedFilesLocally, ignoredFilesLocally, pairFilesuploadedFilesToWhichScopeVar, ignoredFileuploadedFilesToWhichScopeVar, uploadVariableDefinition) {
            var _this = this;
            if (!pairedFilesLocally || pairedFilesLocally.length < 1) {
                return;
            }
            else {
                this.wsData.clearSets();
                this.$scope[pairFilesuploadedFilesToWhichScopeVar] = [];
                this.$scope[ignoredFileuploadedFilesToWhichScopeVar] = ignoredFilesLocally;
                this.$rootScope.$broadcast('messageBoxIgnoreOldMessages');
                var ngProgBar = this.$rootScope.ngProgressBar;
                ngProgBar.set(5);
                this.$rootScope.dimmingPage = true;
                this.$rootScope.$broadcast("dimming_screen_on");
                var _rootScope = this.$rootScope;
                var ajaxQ = new BASWebServices.AjaxQueue(BASWebServices.ConfigService.GET_NUMBER_PARALLEL_UPLOADS(), this.$http, ngProgBar, function () { _rootScope.dimmingPage = false; _rootScope.$broadcast("dimming_screen_off"); ngProgBar.complete(); });
                var pairs = pairedFilesLocally;
                var successCallBack = function (data, status, headers, config) {
                    var wsrlm = new BASWebServices.WebServiceResonseLinkMulti(data);
                    if (!wsrlm.success) {
                        config._this.handleUnsuccessfulUpload(wsrlm.output, wsrlm.warnings, 'File upload unsuccessful', config._this.$rootScope, config._this.$rootScope.ngProgressBar);
                    }
                    else {
                        var filenameString = "";
                        for (var index in wsrlm.downloadLinkList) {
                            var currFile = wsrlm.downloadLinkList[index];
                            if (currFile.lastIndexOf("http") != -1) {
                                var currBaseFilename = currFile.substring(currFile.lastIndexOf("/") + 1, currFile.length);
                                filenameString += currBaseFilename + ", ";
                            }
                        }
                        filenameString = filenameString.substring(0, filenameString.length - 2);
                        var replacement = ' and';
                        filenameString = filenameString.replace(/,([^,]*)$/, replacement + '$1');
                        var statusLabel = 'Success';
                        var warningText = "File upload of " + filenameString;
                        if (wsrlm.warnings != "") {
                            warningText += " resulted in the following warnings: " + wsrlm.warnings;
                            statusLabel += ' (+Warning)';
                        }
                        else {
                            warningText += ' was successfull';
                        }
                        config._this.$rootScope.$broadcast('messageForBox', statusLabel, 'Upload was successful', warningText);
                        config._this.handleSuccessfulUploadSingle(wsrlm.downloadLinkList, uploadedFilesToWhichScopeVar, pairFilesuploadedFilesToWhichScopeVar, uploadVariableDefinition, config.runningNumber);
                    }
                };
                var errorCallBack = function (data, status, headers, config) {
                    config._this.handleUnsuccessfulUpload(data, status, 'File upload unsuccessful', config._this.$rootScope, config._this.$rootScope.ngProgressBar);
                };
                var counter = 0;
                for (var key in pairs) {
                    var formData = new FormData();
                    var currentPair = pairs[key];
                    var totalFileSize = 0;
                    for (var filesIndex in currentPair) {
                        formData.append('file' + counter + filesIndex, currentPair[filesIndex]);
                        if (currentPair[filesIndex].size) {
                            totalFileSize += currentPair[filesIndex].size;
                        }
                    }
                    ajaxQ.ajaxEnqueueFormData(formData, BASWebServices.ConfigService.GET_URL_FILE_MULTI_UPLOAD(), _this, counter, totalFileSize, successCallBack, errorCallBack);
                    counter++;
                }
                this.$scope.$files = [];
            }
        };
        UploadElementMultiController.prototype.resetFiles = function (scopeVariablesToClear) {
            for (var index in scopeVariablesToClear) {
                var currScope = scopeVariablesToClear[index];
                if (this.$scope[currScope] != null) {
                    delete (this.$scope[currScope]);
                    this.$scope[currScope] = null;
                }
            }
            this.wsData.clearSets();
        };
        UploadElementMultiController.prototype.getFilePairsAndIgnoredForTemplateHACK = function (input, pairDefinition) {
            var _this = this;
            var retVal = [];
            var pairs = new Array();
            var ignored = new Array();
            var inputCopy = input.slice(0, input.length);
            var length = inputCopy.length;
            var templateHackFileFile = inputCopy.filter(function (file) {
                if (file.name.lastIndexOf(UploadElementMultiController.TEMPLATE_HACK_FILE_NAME_START) != -1) {
                    return true;
                }
                else {
                    return false;
                }
            });
            if (templateHackFileFile.length > 1) {
                console.error("This should not happen, that there are more than two TEMPLATE files at this point");
            }
            else if (templateHackFileFile.length == 1) {
                inputCopy = $(inputCopy).not(templateHackFileFile).get();
                if (inputCopy.length == 0) {
                    ignored.push(templateHackFileFile[0]);
                    retVal[0] = pairs;
                    retVal[1] = ignored;
                    return retVal;
                }
            }
            inputCopy = inputCopy.sort(function (n1, n2) {
                if (n1.name > n2.name) {
                    return 1;
                }
                if (n1.name < n2.name) {
                    return -1;
                }
                return 0;
            });
            var getUnsupported = function (file) {
                var ext = _this.getExtensionFromURL(file.name);
                if (pairDefinition[ext] == null) {
                    return true;
                }
                else {
                    return false;
                }
            };
            ignored = inputCopy.filter(getUnsupported);
            inputCopy = $(inputCopy).not(ignored).get();
            var pairCount = 0;
            length = inputCopy.length;
            if (templateHackFileFile.length == 0) {
                var i = 0;
                while (i + 1 < length) {
                    var file1 = inputCopy[i];
                    var base1 = this.getBaseFilenameFromURL(file1.name);
                    var ext1 = this.getExtensionFromURL(file1.name);
                    var file2 = inputCopy[i + 1];
                    var base2 = this.getBaseFilenameFromURL(file2.name);
                    var ext2 = this.getExtensionFromURL(file2.name);
                    var pairFound = false;
                    if (base1 == base2) {
                        if (pairDefinition[ext1] != null) {
                            if (pairDefinition[ext1].lastIndexOf(ext2) != -1) {
                                pairs[pairCount] = [file1, file2];
                                pairCount++;
                                inputCopy.splice(i, 2);
                                length -= 2;
                                pairFound = true;
                            }
                        }
                    }
                    if (!pairFound)
                        i++;
                }
            }
            else if (templateHackFileFile.length == 1) {
                var file2 = templateHackFileFile[0];
                var base2 = this.getBaseFilenameFromURL(file2.name);
                var ext2 = this.getExtensionFromURL(file2.name).toLowerCase();
                for (var i = 0; i < length;) {
                    var file1 = inputCopy[i];
                    var base1 = this.getBaseFilenameFromURL(file1.name);
                    var ext1 = this.getExtensionFromURL(file1.name);
                    var allowedExtensions = pairDefinition[ext2];
                    if (allowedExtensions.lastIndexOf(ext1) != -1) {
                        pairs[pairCount] = [file1, file2];
                        pairCount++;
                        inputCopy.splice(i, 1);
                        length--;
                    }
                    else {
                        i++;
                    }
                }
            }
            for (var pairIdx in pairDefinition) {
                if (pairDefinition[pairIdx].lastIndexOf('SINGLE') != -1) {
                    var i = 0;
                    while (i < length) {
                        var file1 = inputCopy[i];
                        var base1 = this.getBaseFilenameFromURL(file1.name);
                        var ext1 = this.getExtensionFromURL(file1.name);
                        var removed = false;
                        if (ext1 == pairIdx.toLowerCase()) {
                            pairs[pairCount] = [file1];
                            pairCount++;
                            inputCopy.splice(i, 1);
                            length--;
                            removed = true;
                        }
                        if (!removed)
                            i++;
                    }
                }
            }
            ignored = ignored.concat(inputCopy);
            retVal[0] = pairs;
            retVal[1] = ignored;
            var duplicates = this.doDuplicatesExistInPairs(retVal);
            if (duplicates) {
                return null;
            }
            return retVal;
        };
        UploadElementMultiController.prototype.doDuplicatesExistInPairs = function (pairIgnoredArray) {
            var pairedFiles = pairIgnoredArray[0];
            var sortFunc = this.isPair1AlphanumericallyHigherThanPair2;
            pairedFiles = pairedFiles.sort(sortFunc);
            for (var pairIdx = 0; pairIdx < pairedFiles.length - 1; pairIdx++) {
                var currPair = pairedFiles[pairIdx];
                var nextPair = pairedFiles[pairIdx + 1];
                var currPairBaseName = UploadElementMultiController.getBasenameForFilePair(currPair);
                var nextPairBaseName = UploadElementMultiController.getBasenameForFilePair(nextPair);
                if (currPairBaseName.toLowerCase() == nextPairBaseName.toLowerCase()) {
                    var errorMsg = "Duplicate for pairing found.";
                    var errorMsgDetail = "There exist two pairs with the same base filename. This can not happen as one of the output files would be overwritten. Please delete one of the files that are paired up. ";
                    errorMsgDetail += "The basename >" + currPairBaseName + "< is causing this error.";
                    this.$rootScope.$broadcast('messageForBox', 'ERROR', errorMsg, errorMsgDetail);
                    return true;
                }
            }
            return false;
        };
        UploadElementMultiController.getBasenameForFilePair = function (pair) {
            var pairName = UploadElementMultiController.getFilenameForFilePair(pair);
            var pairBase = pairName.substring(0, pairName.lastIndexOf("."));
            return pairBase;
        };
        UploadElementMultiController.getFilenameForFilePair = function (pair) {
            var pairName = pair[0].name;
            var templateHackString = UploadElementMultiController.get_TEMPLATE_HACK_FILE_NAME_START();
            if (pairName.lastIndexOf(templateHackString) != -1) {
                pairName = pair[1].name;
            }
            return pairName;
        };
        UploadElementMultiController.prototype.isFileName1AlphanumericallyHigherThanFileName2 = function (n1, n2) {
            if (n1.name > n2.name)
                return 1;
            else if (n1.name < n2.name)
                return -1;
            else
                return 0;
        };
        UploadElementMultiController.prototype.isPair1AlphanumericallyHigherThanPair2 = function (p1, p2) {
            var pairBaseName1 = UploadElementMultiController.getBasenameForFilePair(p1);
            var pairBaseName2 = UploadElementMultiController.getBasenameForFilePair(p2);
            if (pairBaseName1 > pairBaseName2)
                return 1;
            else if (pairBaseName1 < pairBaseName2)
                return -1;
            else
                return 0;
        };
        UploadElementMultiController.prototype.getBaseFilenameFromURL = function (url) {
            var baseFilename = url.substring(url.lastIndexOf("/") + 1, url.lastIndexOf("."));
            return baseFilename;
        };
        UploadElementMultiController.prototype.getExtensionFromURL = function (url) {
            var extension = url.substring(url.lastIndexOf(".") + 1);
            return extension.toLowerCase();
        };
        UploadElementMultiController.prototype.handleSuccessfulUploadSingle = function (filesUploaded, uploadedFilesToWhichScopeVar, pairFilesuploadedFilesToWhichScopeVar, uploadVariableDefinition, pairNumber) {
            if (this.$scope[pairFilesuploadedFilesToWhichScopeVar] == null) {
                this.$scope[pairFilesuploadedFilesToWhichScopeVar] = [];
            }
            var filesUploadedNumericIndex = new Array();
            for (var index in filesUploaded) {
                var currentFileLink = filesUploaded[index];
                if (currentFileLink.lastIndexOf("http") != -1) {
                    this.wsData.add(pairNumber, uploadVariableDefinition[this.getExtensionFromURL(currentFileLink)], currentFileLink);
                    filesUploadedNumericIndex.push(filesUploaded[index]);
                }
            }
            this.$scope[pairFilesuploadedFilesToWhichScopeVar][pairNumber] = filesUploadedNumericIndex;
        };
        UploadElementMultiController.prototype.handleUnsuccessfulUpload = function (data, status, errorMsg, rootScope, progressBar) {
            rootScope.$broadcast('messageForBox', 'ERROR', errorMsg, "Data: " + data + " | Status: " + status);
            progressBar.stop();
            this.$rootScope.dimmingPage = false;
            this.$rootScope.$broadcast("dimming_screen_off");
        };
        UploadElementMultiController.prototype.remove = function (item, scopeVar) {
            var index = this.$scope[scopeVar].indexOf(item);
            var pair = this.$scope[scopeVar].splice(index, 1);
            for (var indexInPair = 0; indexInPair < pair[0].length; indexInPair++) {
                var indexCurrent = this.$scope.$files.indexOf(pair[0][indexInPair]);
                this.$scope.$files.splice(indexCurrent, 1);
            }
        };
        UploadElementMultiController.prototype.noFilesDragedAndDropped = function () {
            var _scope = this.$scope;
            this.ngDialog.open({
                template: 'views/partials/dialogs/noFilesToUploadWarning.html',
                className: 'ngdialog-theme-default',
                closeByEscape: true,
                scope: _scope
            });
        };
        UploadElementMultiController.TEMPLATE_HACK_FILE_NAME_START = "_TEMPLATE_FILE_";
        return UploadElementMultiController;
    }());
    BASWebServices.UploadElementMultiController = UploadElementMultiController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=UploadElementMultiController.js.map